import { BridgeComponent } from "@hotwired/hotwire-native-bridge";
import { BridgeElement } from "@hotwired/hotwire-native-bridge";

export default class extends BridgeComponent {
  static component = "form";
  static targets = ["submit"];

  connect() {
    super.connect();
    this.notifyBridgeOfConnect();
  }

  notifyBridgeOfConnect() {
    const submitButton = new BridgeElement(this.submitTarget);
    const title = submitButton.title;

    this.send("connect", { title }, () => {
      this.submitTarget.click();
    });
  }

  submitStart(event) {
    this.submitTarget.disabled = true;
    this.send("submitDisabled");
  }

  submitEnd(event) {
    this.submitTarget.disabled = false;
    this.send("submitEnabled");
  }
}
